<template>
  <el-form
    ref="addForm"
    :inline="true"
    :model="addForm"
    :rules="rules"
    class="searchBoxLine form-wrap"
  >
    <el-form-item label="显示名称:" prop="fieldDisplayName" clearable>
      <el-input
        v-model="addForm.fieldDisplayName"
        placeholder="请填写显示名称名称"
        maxlength="255"
        @change="handleChange"
        @input="e => addForm.fieldDisplayName = handleInputRule (e)"
      />
    </el-form-item>
    <el-form-item label="对应表字段:" prop="fieldData">
      <queryField v-model="addForm.fieldData" @change="handleChange" />
    </el-form-item>

    <el-form-item label="类型:" prop="attributeType">
      <el-select
        v-model="addForm.attributeType"
        style="width: 130px"
        placeholder="请选择"
        @change="handleChange"
      >
        <el-option
          v-for="(item, index) in msgType"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="是否数据库读取:" prop="dataEcho">
      <el-select
        v-model="addForm.dataEcho"
        :disabled="addForm.attributeType === '只读文本'"
        style="width: 130px"
        placeholder="请选择"
        @change="handleChange"
      >
        <el-option
          v-for="(item, index) in isEcho"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="是否必填:" prop="isRequired">
      <el-select
        v-model="addForm.isRequired"
        style="width: 130px"
        placeholder="请选择"
        @change="handleChange"
      >
        <el-option
          v-for="(item, index) in isTrue"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import { MSG_TYPE, IS_TRUE, IS_ECHO } from '@/libs/constant';
import queryField from '../queryField/index.vue';
import { handleInputRule } from '@/libs/util.js';

export default {
  components: {
    queryField
  },

  model: {
    prop: 'data',
    event: 'change'
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      addForm: {
        fieldData: {},
        fieldDisplayName: '',
        attributeType: '输入框',
        isRequired: true,
        dataEcho: 1
      },
      msgType: MSG_TYPE,
      isTrue: IS_TRUE,
      isEcho: IS_ECHO,
      rules: {
        fieldDisplayName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        fieldData: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        attributeType: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        dataEcho: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        isRequired: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      }
    };
  },

  watch: {
    addForm (newVal) {
      let json = newVal;
      if (json.fieldData && json.fieldData.fieldKey) {
        json.fieldId = json.fieldData.id;
        json.fieldKey = json.fieldData.fieldKey;
      }
      this.$emit('change', { ...json, id: this.data.id });
    }
  },

  methods: {
    handleInputRule,
    // 解决watch监听不到属性值变化问题
    handleChange () {
      this.addForm = Object.assign({}, this.addForm);
    },

    validateForm (callBack) {
      this.$refs.addForm.validate((valid) => {
        if (callBack) callBack(valid);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrap {
  display: inline-block;
}

.form-item-width{
  width: 130px;
}
</style>
